import classNames from 'classnames';
import React, { ReactNode } from 'react';

interface ITag {
  tagType: 'success' | 'warning' | 'caution' | 'danger' | 'neutral' | 'default' | 'purple' | 'brown' | 'info';
  filled?: boolean;
  children: ReactNode;
}
const Tag = (props: ITag) => {
  const { tagType, filled, children } = props;

  return (
    <div
      className={classNames(
        'w-fit rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize transition-colors md:text-sm',

        { 'border-tag-green bg-white text-tag-green': tagType === 'success' && !filled },
        { 'border-tag-green bg-tag-green text-white': tagType === 'success' && filled },

        { 'border-tag-yellow bg-white text-tag-yellow': tagType === 'warning' && !filled },
        { 'border-tag-yellow bg-tag-yellow text-white': tagType === 'warning' && filled },

        { 'border-tag-orange bg-white text-tag-orange': tagType === 'caution' && !filled },
        { 'border-tag-orange bg-tag-orange text-white': tagType === 'caution' && filled },

        { 'border-tag-red bg-white text-tag-red': tagType === 'danger' && !filled },
        { 'border-tag-red bg-tag-red text-white': tagType === 'danger' && filled },

        { 'border-tag-gray bg-white text-tag-gray': tagType === 'neutral' && !filled },
        { 'border-tag-gray bg-tag-gray text-white': tagType === 'neutral' && filled },

        { 'border-black bg-white text-black': tagType === 'default' && !filled },
        { 'border-black bg-black text-white': tagType === 'default' && filled },

        { 'border-tag-purple bg-white text-tag-purple': tagType === 'purple' && !filled },
        { 'border-tag-purple bg-tag-purple text-white': tagType === 'purple' && filled },

        { 'border-tag-brown bg-white text-tag-brown': tagType === 'brown' && !filled },
        { 'border-tag-brown bg-tag-brown text-white': tagType === 'brown' && filled },

        { 'border-tag-info bg-white text-tag-info': tagType === 'info' && !filled },
        { 'border-tag-info bg-tag-info text-white': tagType === 'info' && filled }
      )}
    >
      {children}
    </div>
  );
};

export default Tag;
